<template>
  <div class="col-12">
    <section-title
      class="mt-3"
      content="Firmas del Especialista"
      :has-line="true"
    />
    <row-message
      class="row-message"
      text="Si desea editar la información de los firmantes lo deberá realizar directamente en el perfil del Especialista."
      warning
    />
    <div class="pt-2">
      <div class="result-table">
        <div class="row py-2 mr-md-0">
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">
                Nombre del Especialista:
              </div>
              <div class="color-black font-16 bold">
                {{ writerSpecialist.fullName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Número de Licencia</div>
              <div class="color-black font-16 bold">
                {{ writerSpecialist.licenceNo }}
              </div>
            </div>
          </div>
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-10">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ writerSpecialist.email }} / {{ writerSpecialist.userName }}
              </div>
            </div>
            <div class="col-md-1">
              <div class="color-gray-6 font-14">Rol:</div>
              <div class="color-black font-16 bold">
                Especialista
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import RowMessage from '@/components/common/RowMessage.vue';

export default {
  name: 'SignaturesSpecialist',
  components: {
    SectionTitle,
    RowMessage,
  },
  data: () => ({
    data: [],
  }),
  props: {
    writerSpecialist: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
</style>
